/* eslint-disable */

'use strict';

import * as util from 'shared/js/util/index';

export default function (Alpine) {
    Alpine.magic('_', () => util);
}
